import SectionLabel from "@/components/base/SectionLabel";
import { dxAdvisoryData } from "@/mocks/dxAdvisoryData";

export default function MonthlyCycleSection() {
  return (
    <section id="monthly-cycle" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-14 md:mb-18 reveal">
          <SectionLabel label={dxAdvisoryData.monthlyCycle.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {dxAdvisoryData.monthlyCycle.title}
          </h2>
        </div>

        {/* Desktop: Circular flow with prominent center */}
        <div className="hidden lg:block">
          <div className="flex justify-center reveal">
            <div className="relative w-[560px] h-[560px]">
              {/* Ferris wheel: outer orbits clockwise, each block counter-rotates */}
              <div className="absolute inset-0 animate-ferris-orbit">
              {dxAdvisoryData.monthlyCycle.steps.map((step, idx) => {
                const angles = [-135, -45, 45, 135];
                const angle = (angles[idx] * Math.PI) / 180;
                const radius = 195;
                const x = Math.cos(angle) * radius;
                const y = Math.sin(angle) * radius;

                return (
                  <div
                    key={step.num}
                    className="absolute"
                    style={{
                      top: `calc(50% + ${y}px)`,
                      left: `calc(50% + ${x}px)`,
                      transform: "translate(-50%, -50%)",
                    }}
                  >
                    <div
                      className="animate-ferris-counter flex flex-col items-center text-center"
                      style={{ width: "160px" }}
                    >
                      <div className="relative mb-3">
                        <div className="w-14 h-14 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-lg font-bold font-heading">
                          {step.num}
                        </div>
                      </div>
                      <h3 className="text-sm font-bold text-foreground-900 mb-1.5 font-heading">
                        {step.title}
                      </h3>
                      <p className="text-xs text-foreground-600 leading-relaxed">
                        {step.desc}
                      </p>
                    </div>
                  </div>
                );
              })}
              </div>

              {/* Center message */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 rounded-full bg-primary-50 border-2 border-primary-200/60 flex items-center justify-center z-10">
                <p className="text-base font-bold text-primary-700 text-center leading-relaxed font-heading px-6">
                  {dxAdvisoryData.monthlyCycle.centerText}
                </p>
              </div>

              {/* Circular arrow SVG */}
              <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 560 560">
                <defs>
                  <marker id="cycleArrow" markerWidth="10" markerHeight="8" refX="10" refY="4" orient="auto">
                    <polygon points="0 0, 10 4, 0 8" fill="oklch(0.72 0.18 55 / 0.35)" />
                  </marker>
                </defs>
                <path
                  d="M 175 100 A 195 195 0 0 1 385 100 A 195 195 0 0 1 385 460 A 195 195 0 0 1 175 460 A 195 195 0 0 1 175 100"
                  fill="none"
                  stroke="oklch(0.72 0.18 55 / 0.25)"
                  strokeWidth="2"
                  strokeDasharray="10 5"
                  markerEnd="url(#cycleArrow)"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Mobile/Tablet: Vertical flow */}
        <div className="lg:hidden space-y-0">
          {dxAdvisoryData.monthlyCycle.steps.map((step, idx) => (
            <div
              key={step.num}
              className="reveal flex gap-4 md:gap-5 items-start relative"
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <div className="flex flex-col items-center pt-1">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-base md:text-lg font-bold font-heading flex-shrink-0">
                  {step.num}
                </div>
                {idx < dxAdvisoryData.monthlyCycle.steps.length - 1 && (
                  <div className="w-px flex-1 min-h-[50px] bg-primary-200 mt-2" />
                )}
              </div>
              <div className="pb-8 pt-2.5 md:pt-3">
                <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-1.5 font-heading">
                  {step.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile center message */}
        <div className="lg:hidden text-center mt-2 reveal">
          <div className="inline-block px-6 py-3 rounded-full bg-primary-50 border border-primary-200/60">
            <p className="text-sm font-bold text-primary-700 font-heading">
              {dxAdvisoryData.monthlyCycle.centerText}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}